import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  ListArInvoicesInput,
  ListArInvoicesResponse,
  GetArInvoiceResponse,
  ArInvoiceListItem,
} from '@erp/rpc';

export function useArInvoicesList(filters: ListArInvoicesInput = {}) {
  const query = useQuery(
    orpc.accountsReceivable.arInvoices.list.queryOptions({ input: filters }),
  );

  const invoices = query.data?.invoices ?? [];
  const pagination = query.data?.pagination;

  return {
    ...query,
    invoices,
    pagination,
  } satisfies typeof query & {
    data?: ListArInvoicesResponse;
    invoices: ArInvoiceListItem[];
    pagination: ListArInvoicesResponse['pagination'] | undefined;
  };
}

export function useArInvoice(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.accountsReceivable.arInvoices.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    invoice: query.data?.invoice ?? null,
  } satisfies typeof query & {
    data?: GetArInvoiceResponse;
    invoice: GetArInvoiceResponse['invoice'] | null;
  };
}
